<script context="module">
  import '../../../../node_modules/bootstrap/js/dist/collapse';
  import Icon from '../../common/components/Icon.svelte';
</script>

<script lang="ts">
  export let title = 'title';
  export let collpasableId = 'collapseExample';
  let isOpen = false;

  function toggleIcon() {
    isOpen = !isOpen;
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  data-bs-toggle="collapse"
  class="js-footer-second-level-toggle title collapsed d-flex justify-content-between collapsed"
  data-bs-target={`#${collpasableId}`}
  aria-controls="collapseExample"
  aria-expanded="false"
  on:click={toggleIcon}
>
  <span class="text-title">{title}</span>
  <Icon glyph="chevron_down" />
</div>
<div class="d-lg-none collapse" id={collpasableId}>
  <slot />
</div>
<div class="d-none d-lg-block">
  <slot />
</div>

<style lang="scss">
  @import '../../../common/styles/vars';
  // .title {
  //   border-bottom: solid 0.1rem $color-alabaster-gray;
  //   color: $color-white;
  //   display: block;
  //   font-size: 1.4rem;
  //   font-weight: 600;
  //   line-height: 1.43;
  //   padding: 1.1rem 2rem;
  //   position: relative;
  //   margin-bottom: 0;
  //   margin-top: 0;

  //   .c_icon {
  //     font-size: 1.4rem;
  //   }
  //   &:not(.collapsed) .c_icon {
  //     transform: rotateZ(180deg);
  //   }
  // }

  .text-title {
    color: $color-white;
    display: block;
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 1.43;
  }

  @media screen and (min-width: 1024px) {
    .title {
      border-bottom: 0;
      display: inline-block;
      font-size: 2rem;
      padding: 0 0 2rem;
      pointer-events: none;
    }

    .text-title {
      border-bottom: 0;
      display: inline-block;
      font-size: 2rem;

      pointer-events: none;
    }
  }
  .title {
    :global(.c_icon_new--chevron_down) {
      font-weight: 700;
      filter: drop-shadow(0 0 1px currentColor);
      text-shadow:
        0 0 1px currentColor,
        0 0 1px currentColor;
    }
  }
</style>
